import { render } from "./intelligentDetection.vue?vue&type=template&id=3ef58b51&scoped=true"
import script from "./intelligentDetection.vue?vue&type=script&lang=js"
export * from "./intelligentDetection.vue?vue&type=script&lang=js"

import "./intelligentDetection.vue?vue&type=style&index=0&id=3ef58b51&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef58b51"]])

export default __exports__